import { Typography } from 'antd'
import { TitleProps } from 'antd/lib/typography/Title'
import React from 'react'

const { Title: AntdTitle } = Typography

type FontWeight = 500 | 600 | 700

type Props = {
  color?: string
  weight?: FontWeight
  className?: string
  children: React.ReactNode
  level?: TitleProps['level']
}

export const Title = ({
  weight = 600,
  className,
  children,
  level,
  color
}: Props) => {
  return (
    <AntdTitle
      style={{ fontWeight: weight, color }}
      className={className}
      level={level}
    >
      {children}
    </AntdTitle>
  )
}
